export default __webpack_public_path__ + "images/a922aade97c18240c69b8542fa441e64-adopt-cat-background-670.png";